import classnames from 'classnames'
import { FormikProvider, useFormik } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'

import useAddMembersToGroups from '../../../state/mutations/useAddMembersToGroups'
import FormButtons from '../../basics/FormButtons/FormButtons'
import { SelectGroupsFormik } from '../../formElements/SelectGroups/SelectGroups'
import UserSlugs from '../../slugs/UserSlugs'

import styles from './AddGroupMembershipsToUsersForm.module.scss'

interface AddGroupMembershipsToUsersFormProps {
  userUuids: string[]
  onClose: () => void
}

export default React.memo(function AddGroupMembershipsToUsersForm({
  userUuids,
  onClose,
}: AddGroupMembershipsToUsersFormProps) {
  const { t } = useTranslation()

  const addMembersToGroups = useAddMembersToGroups()
  const formik = useFormik({
    initialValues: {
      userUuids,
      groupUuids: [],
    },
    onSubmit: async (values, { setStatus }) => {
      setStatus()
      try {
        await addMembersToGroups.mutateAsync(values)
        onClose()
      } catch (err) {
        setStatus(err)
      }
    },
  })

  return (
    <FormikProvider value={formik}>
      <form noValidate onSubmit={formik.handleSubmit} className={classnames(styles.AddGroupMembershipsToUsersForm)}>
        <header>
          <hgroup>
            <h1>{t('manage group.add to group')}</h1>
          </hgroup>
        </header>

        <UserSlugs uuids={formik.values.userUuids} max={5} className={styles.users} />

        <SelectGroupsFormik name="groupUuids" />

        <FormButtons onClose={onClose} {...formik} />
      </form>
    </FormikProvider>
  )
})
